module.exports = __webpack_public_path__ + "img/img_zhanhaoyun@2x.4de28054.png";